module.exports = __webpack_public_path__ + "img/icon_daolan21.44a1c69c.svg";